module.exports = __webpack_public_path__ + "img/walkie-talkie.226e2931.svg";